import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputIcon } from 'primereact/inputicon';
import { IconField } from 'primereact/iconfield';
import { Password } from 'primereact/password';
import { Link } from 'react-router-dom';
import { PreLoginWrapper } from './PreLoginWrapper';

export const Register = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    const navigate = useNavigate();

    useEffect(() => {
        if (accessToken && refreshToken) {
            navigate('/fields');
        }
    }, [accessToken, refreshToken, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setTimeout(() => {
                setError('Las contraseñas no coinciden');
            }, 100);
            return;
        }

        const payload = {
            email: email,
            password: password
        };

        try {
            const response = await fetch("/vitisad/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (response.status === 201) {
                try {
                    const loginResponse = await fetch("/vitisad/login", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(payload)
                    });

                    const loginData = await loginResponse.json();
                    const accessToken = loginData.accessToken;
                    const refreshToken = loginData.refreshToken;

                    if (accessToken === undefined || refreshToken === undefined) {
                        setError(loginData.error || "Error al iniciar sesión después del registro");
                    } else {
                        localStorage.setItem('accessToken', accessToken);
                        localStorage.setItem('refreshToken', refreshToken);
                        navigate('/fields');
                    }
                } catch (loginError) {
                    setError("Error al iniciar sesión después del registro");
                }
            } else {
                setError("Error al iniciar sesión después del registro");
            }
        } catch (error) {
            setError("Error al registrar el usuario");
        }
    };

    return (
        <PreLoginWrapper error={error}>
            <p className="p-component mb-5 font-semibold w-full">{('Introduce tus credenciales de acceso:')}</p>
            
            <form className='w-full' onSubmit={handleSubmit}>

                <IconField className="w-full mb-3" iconPosition="left">
                    <InputIcon 
                        className="pi pi-envelope ml-2" 
                        style={{ color: 'black' }}
                        aria-label="Email icon"
                        tabIndex="-1"
                    />
                    <InputText 
                        placeholder={('Email')}
                        type="email"
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        className="w-full pl-6"
                        required
                    />
                </IconField>
                
                <IconField className="w-full mb-3" iconPosition="left">
                    <InputIcon 
                        className="pi pi-lock ml-2" 
                        style={{ color: 'black', zIndex: 1 }}
                        aria-label="Password icon"
                        tabIndex="-1"
                    />
                    <Password 
                        placeholder={('Contraseña')}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} 
                        feedback={false} 
                        toggleMask 
                        inputClassName="w-full pl-6"
                        className="w-full"
                        pt={{ iconField: { root: { className: 'w-full' } } }} 
                        required
                    />
                </IconField>

                <IconField className="w-full mb-5" iconPosition="left">
                    <InputIcon 
                        className="pi pi-lock ml-2" 
                        style={{ color: 'black', zIndex: 1 }}
                        aria-label="Password icon"
                        tabIndex="-1"
                    />
                    <Password 
                        placeholder={('Confirmar contraseña')}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)} 
                        feedback={false} 
                        toggleMask 
                        inputClassName="w-full pl-6"
                        className="w-full"
                        pt={{ iconField: { root: { className: 'w-full' } } }} 
                        required
                    />
                </IconField>

                <Button 
                    label={loading ? ('Cargando...') : ('Registrarme')} 
                    disabled={loading} 
                    className="bg-primary w-full" 
                />

                <p className="p-component mb-5 w-full text-center">¿Ya tienes una cuenta? <Link to="/login" className="text-primary">Inicia sesión</Link></p>

            </form>
            
        </PreLoginWrapper>
    );
};
